<template>
	<div class="m-menu flex-wrap">
		<div v-for="(item, i) in menuList" :key="i" class="item flex-column flex-center" :class="[`col${colLength}`]">
			<c-image class="image" :src="item.img_url" mode="aspectFill" :background="false"></c-image>
			<p class="ellipsis">{{item.title}}</p>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				menuList: [],
				colLength: ''
			}
		},
		
		mounted() {
		},
		
		methods: {
			set(data) {
				this.menuList = data.list;
				this.colLength = data.row_number;
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-menu {
		border-radius: 6px;
		padding: 10px 0;
		margin: 10px;
		background: #fff;
		
		.item {
			&.col4 {
				width: 25%;
				height: 86px;
				
				&:nth-child(n+9) {
					display: none;
				}
				
				&:nth-child(n+5) {
					margin-top: 6px;
				}
				
				.image {
					width: 62px;
					height: 62px;
				}
			}
			
			&.col5 {
				width: 20%;
				height: 80px;
				
				&:nth-child(n+11) {
					display: none;
				}
				
				&:nth-child(n+6) {
					margin-top: 6px;
				}
				
				.image {
					width: 52px;
					height: 52px;
				}
			}
			
			p {
				box-sizing: border-box;
				width: 100%;
				padding: 0 5px;
				margin-top: 5px;
				line-height: 15px;
				font-size: 13px;
				text-align: center;
				color: #666;
			}
		}
	}
</style>
